import get from 'lodash.get';

import { SprayExportProduct, SpraySubmissionProduct } from './types';

export function formatResponseData(
    data: SprayExportProduct[]
): SpraySubmissionProduct[] {
    return data.map((row) => {
        const sprayEntities = get(
            row,
            ['sprayEventProduct', 'sprayEvent', 'sprayEntities'],
            [] as { id: number }[]
        );

        return {
            ...row,
            sprayEntityIds: sprayEntities.map(({ id }) => id),
            sprayEventProduct: undefined
        };
    });
}
